import store from "@/store";

import Navbar from "@/layout/Navbar.vue";
import Sidebar from "@/layout/Sidebar.vue";

/**
 *  beforeEnter Navigation guards
 *  hasAuth
 */
const hasAuth = (to, from, next) => {
    let isLoggedIn = store.getters["auth/isLoggedIn"];
    if (to.params.id && !isLoggedIn) {
        return next("/login");
    }
    next();
};

const sedUserRoutes = [
    {
        path: "/sed-users",
        name: "SedUsers",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SedUsers" */ "@/views/SedUsers/SedUsers.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/sed-user/:id",
        name: "SedUser",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SedUser" */ "@/views/SedUsers/SedUser.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/sed-user-create-edit/:id?",
        name: "SedUserCreateEdit",
        beforeEnter: hasAuth,
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SedUsersCreateEdit" */ "@/views/SedUsers/SedUserCreateEdit.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: false,
        },
    },

    {
        path: "/inactive-sed-users",
        name: "InactiveSedUsers",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "InactiveSedUsers" */ "@/views/SedUsers/InactiveSedUsers.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/collect-recycle-reports/:id",
        name: "CollectRecycleReports",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "CollectRecycleReports" */ "@/views/SedUsers/CollectRecycleReports.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/collect-recycle-reports/:id/collect-report",
        name: "CollectReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "CollectReport" */ "@/views/SedUsers/CollectReport.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/collect-recycle-reports/:id/recycle-report",
        name: "RecycleReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "RecycleReport" */ "@/views/SedUsers/RecycleReport.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/collect-recycle-reports/:id/veas-report",
        name: "VeasReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "VeasReport" */ "@/views/SedUsers/VeasReport.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/collect-recycle-reports-log/:id",
        name: "CollectRecycleReportsLog",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "CollectRecycleReportsLog" */ "@/views/SedUsers/CollectRecycleReportsLog.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: false,
        },
    },

    {
        path: "/sed-quantities-report",
        name: "SedQuantitiesReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SedQuantitiesReport" */ "@/views/SedUsers/SedQuantitiesReport.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/sed-comparison-report",
        name: "SedComparisonReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SedComparisonReport" */ "@/views/SedUsers/SedComparisonReport.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },
    {
        path: "/sed-industrial-packaging-waste-report",
        name: "SedIndustrialPackagingWasteReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SedIndustrialPackagingWasteReport" */ "@/views/SedUsers/SedIndustrialPackagingWasteReport.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },
];

export default sedUserRoutes;
